import { arrayContains } from 'utils';
import { ATTEND_INSURANCE_COOPERATION_USER_DATA_FAILURE } from 'redux/actions';

export const isAttendInsuranceNumberFailed = (state) =>
  arrayContains(state.entities.users.failedRequests, [ATTEND_INSURANCE_COOPERATION_USER_DATA_FAILURE]);
